<div class="form-control input input-with-text input-date icon icon-calendar single dsadsadsa">
  <input
    id="txtCalendarPolicyDate"
    type="text"
    name="calPolicyDate"
    data-type="daterange"
    readonly
    placeholder="Selecciona una fecha"
    class="text-input inline text-09-d-demibold"
    [class.error]="validationUiService.isInsuredSubmit && !validationUiService.isPolicyStartRealDate(contractType)"
    style="cursor: pointer;" />
                            <p
                      id="errorTxtCalendarPolicyDate"
                      class="error-txt"
                      [class.hidden]="!validationUiService.isInsuredSubmit || (validationUiService.isInsuredSubmit && validationUiService.isPolicyStartRealDate(contractType))">
                      {{ questionError}}
                    </p>
</div>
